import { Order, Transfer, OfferOrder } from 'src/models';

export const isOrder = (value: Order | OfferOrder | Transfer): value is Order => Boolean((value as any).symbol);

export const isTransfer = (value: Order | OfferOrder | Transfer): value is Transfer =>
  Boolean((value as any).mechanism);
